<template>
  <Modal
    @close="$emit('close')"
    :classes="'col-md-5'"
    :title="'Recomienda Beereaders a un colega'"
  >
    <div slot="body" class="body">
      <form @submit="send($event)">
        <div class="row">
          <div class="col">
            <CustomInput :icon="'fa fa-envelope'">
              <input
                type="email"
                slot="input"
                placeholder="Escriba el correo electrónico"
                v-model="email"
              />
            </CustomInput>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <vue-editor
              v-model="recommendationText"
              :editor-toolbar="customToolbar"
            />
          </div>
        </div>
        <div class="row pt-2">
          <div class="col text-center">
            <button type="submit" :disabled="!email" class="button logo">
              Recomendar
            </button>
          </div>
        </div>
      </form>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal";
import CustomInput from "@/components/CustomInput";
import { VueEditor } from "vue2-editor";
import { mapState } from "vuex";

export default {
  name: "RecommendationModal",
  components: {
    Modal,
    CustomInput,
    VueEditor,
  },
  data() {
    return {
      recommendationText:
        '<p>Hola. Estoy usando <a href="https://www.beereaders.com/" rel="noopener noreferrer" target="_blank">www.beereaders.com</a> para ayudar a mis estudiantes a mejorar su compresión lectora. Tú también deberías usarlo.</p>',
      customToolbar: [[]],
      email: "",
    };
  },
  computed: {
    ...mapState(["dataUrl", "userData"]),
  },
  methods: {
    async send(e) {
      e.preventDefault();
      let apiUrl = `${this.dataUrl}/bookUser/recommendTeachers`;

      let loader = this.$loading.show();

      try {
        let { data } = await this.axios.post(apiUrl, {
          userId: this.userData.id,
          mailTo: this.email,
          mailSubject: "Recomendación",
          mailContent: {
            text: `<!DOCTYPE html>
            <html class="no-js" lang="en-US">
              <head>
                <meta charset="utf-8" />
                <title>Recomendación Beereaders</title>
                <meta http-equiv="x-ua-compatible" content="ie=edge" />
                <style>
                  .colorBTNActive:hover {
                    background-color: #4C4E56 !important;
                  }
                  .btn:hover {
                    color: #212529 !important;
                    text-decoration: none;
                  }

                  [type=button]:not(:disabled), [type=reset]:not(:disabled), [type=submit]:not(:disabled), button:not(:disabled) {
                    cursor: pointer;
                  }
                  .sectionButton {
                    width: max-content;
                  }
                  .colorBTNActive {
                    background-color: #FCB512 !important;
                    display: inline-block;
                    width: max-content;
                  }
                  .m-auto {
                    margin: auto!important;
                  }
                  .pl-4, .px-4 {
                    padding-left: 1.5rem!important;
                  }
                  .pr-4, .px-4 {
                    padding-right: 1.5rem!important;
                  }
                  .pb-2, .py-2 {
                    padding-bottom: .5rem!important;
                  }
                  .pt-2, .py-2 {
                    padding-top: .5rem!important;
                  }
                  .rounded-pill {
                    border-radius: 50rem!important;
                  }
                  .btn {
                    display: inline-block;
                    font-weight: 400;
                    color: #212529;
                    text-align: center;
                    vertical-align: middle;
                    cursor: pointer !important;
                    -webkit-user-select: none;
                    -moz-user-select: none;
                    -ms-user-select: none;
                    user-select: none;
                    background-color: transparent;
                    border: 1px solid transparent;
                    padding: .375rem .75rem;
                    font-size: 1rem;
                    line-height: 1.5;
                    border-radius: .25rem;
                    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out !important;
                  }
                  .ubuntu {
                    font-family: 'Ubuntu', sans-serif;
                  }

                  .text-white {
                    color: #fff!important;
                  }

                  .subtitle {
                    font-size: 1.09rem;
                  }
                  .subtitle {
                    color: #999999;
                  }
                  .h4 {
                    font-size: 1.5rem !important;
                  }
                  .text-dark {
                    color: #4f4537 !important;
                  }
                  a {
                    text-decoration: none;
                  }
                </style>
              </head>
              <body>
                Recomendado por,
                <br>
                Nombre: ${this.userData.firstname} ${this.userData.lastname}
                <br>
                Correo: ${this.userData.email}
                <br>
                <div style="text-align: center;">
                  <img src="https://res.cloudinary.com/josue-martinez/image/upload/v1583097432/resources/kalakai_xfwgxi.png" />
                  <div class="subtitle text-dark h4">
                    ${this.recommendationText}
                  </div>
                  <br>
                  <button class="btn colorBTNActive rounded-pill px-4 py-2 sectionButton m-auto" type="submit">
                    <a class="text-white ubuntu" href="https://www.beereaders.com/site/request_es.html">
                      PEDIR UN DEMO
                    </a>
                  </button>
                </div>
              </body>
            </html>`,
            html: true,
          },
          contentType: "html",
        });

        if (data.status.name.toLocaleLowerCase() == "ok") {
          this.$notify({
            title: ["Correo enviado con éxito"],
            type: "success",
          });
        } else {
          this.$notify({
            title: ["Ocurrió un error", data.content],
            type: "danger",
          });
        }
      } catch {
        this.$notify({
          title: ["Ocurrió un error"],
          type: "danger",
        });
      } finally {
        loader.hide();
      }
    },
  },
};
</script>

<style lang="scss">
.ql-toolbar {
  display: none;
}
#quill-container {
  border: 1px solid #ccc !important;
}
.ql-tooltip {
  display: none;
}
</style>
